module.exports = __webpack_public_path__ + "static/media/bg_price_plan_from_40_to_44.c28fe1ab.webp";